"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumeric = void 0;

// Whether the value can be converted to be a number
var isNumeric = function isNumeric(value) {
  var convertedValue = parseFloat(value);
  return !Number.isNaN(convertedValue);
};

exports.isNumeric = isNumeric;
//# sourceMappingURL=numbers.js.map